import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

/* Vite injects the value of `base` from vite.config.ts into
   `import.meta.env.BASE_URL`. Currently set to "/" for both dev and prod.
   We trim the trailing slash for consistency with BrowserRouter expectations. */
const basename = (import.meta.env.BASE_URL ?? '/').replace(/\/$/, '');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
